import { render, staticRenderFns } from "./TraspasosList.vue?vue&type=template&id=495d3b99&"
import script from "./TraspasosList.vue?vue&type=script&lang=js&"
export * from "./TraspasosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports